import React from 'react'
import { Waves } from '@pergas-common/pergas-components'

export default function ({ children, loading }) {
  return loading ? <Waves width={18} height={18} /> : children
}
